<div class="cus-snakebar">
    <mat-icon>{{getIcon}}</mat-icon>&nbsp;<span>{{ data?.message }}</span>
    <button mat-button class="ml-auto" (click)="closeSnackbar()">
        {{data.action}}
    </button>
</div>